import { bboxCenter } from "utils/math/bboxCenter";
import { ZOOM_CONFIG } from "../../constants";
import type { ComputeZoomToBbox } from "./types";

export const computeZoomToBbox: ComputeZoomToBbox = ({
  bbox,
  containerWidth,
  containerHeight,
  minZoom,
  maxZoom,
}) => {
  const bboxWidth = Math.max(Math.abs(bbox.x2 - bbox.x1), 1);
  const bboxHeight = Math.max(Math.abs(bbox.y2 - bbox.y1), 1);

  const fillZoom =
    ZOOM_CONFIG.AUTO_ZOOM_FILL_FRACTION *
    Math.min(containerWidth / bboxWidth, containerHeight / bboxHeight);
  const zoom = Math.max(minZoom, Math.min(maxZoom, fillZoom));

  const center = bboxCenter({ bbox });

  return {
    zoom,
    panX: containerWidth / 2 - center.x * zoom,
    panY: containerHeight / 2 - center.y * zoom,
  };
};
